import {
    fetchBasicGetJson,
    fetchBasicJsonPost,
    fetchBasicJsonPostJson
} from '@/script/common';

export default {
    constant: {
        enum: (function() {
            var _locals = {
                tableActions: null,
                additionalFilterTypes: null
            };
            return {
                async tableActions() {
                    if (_locals.tableActions === null) {
                        await fetchBasicGetJson(
                            '/Workflow/GetTableActions'
                        ).then(resp => (_locals.tableActions = resp));
                    }
                    return _locals.tableActions;
                },
                async additionalFilterTypes() {
                    if (_locals.additionalFilterTypes === null) {
                        await fetchBasicGetJson(
                            '/Workflow/GetAdditionalFilterTypes'
                        ).then(resp => (_locals.additionalFilterTypes = resp));
                    }
                    return _locals.additionalFilterTypes;
                }
            };
        })()
    },
    GetTableFields: table_id => {
        return fetchBasicJsonPostJson('/Workflow/GetTableFields', {
            data: {
                table: table_id
            }
        });
    },
    Default: {
        getData: (page, itemsPerPage, filter) => {
            var parameters = {
                page: page,
                pageSize: itemsPerPage
            };
            parameters.grid_type = filter.grid_type || 1;
            parameters.table = filter.table || null;
            parameters.action = filter.action || null;
            parameters.level = filter.level || null;
            parameters.created_by = filter.created_by || null;
            parameters.status = filter.status || null;
            parameters.created_at_start = filter.created_at_start || null;
            parameters.created_at_end = filter.created_at_end || null;
            parameters.history_code = filter.history_code || null;
            return fetchBasicJsonPostJson('/Workflow/GetDataTableData', {
                data: parameters
            });
        },
        getRequestData: (requestId, onlyBasic) => {
            return fetchBasicJsonPostJson('/Workflow/RequestData', {
                data: {
                    RequestId: requestId,
                    OnlyBasic: onlyBasic || false
                }
            });
        },
        approve: (requestId, generatorId, comment) => {
            return fetchBasicJsonPost('/Workflow/Approve', {
                data: {
                    RequestId: requestId,
                    GeneratorId: generatorId,
                    Comment: comment
                }
            });
        },
        reject: (requestId, generatorId, comment) => {
            return fetchBasicJsonPost('/Workflow/Reject', {
                data: {
                    RequestId: requestId,
                    GeneratorId: generatorId,
                    Comment: comment
                }
            });
        },
        approveAll: (history_code, ids, comment) => {
            return fetchBasicJsonPost('/Workflow/ApproveAll', {
                data: {
                    history_code: history_code,
                    ids: ids,
                    comment: comment
                }
            });
        },
        rejectAll: (history_code, ids, comment) => {
            return fetchBasicJsonPost('/Workflow/RejectAll', {
                data: {
                    history_code: history_code,
                    ids: ids,
                    comment: comment
                }
            });
        }
    },
    Approver: {
        getData: (page, itemsPerPage, filter) => {
            var parameters = {
                page: page,
                pageSize: itemsPerPage
            };
            parameters.generator_id = filter.generator_id;
            parameters.level = filter.level;
            return fetchBasicJsonPostJson(
                '/Workflow/GetApproverDataTableData',
                {
                    data: parameters
                }
            );
        },
        add: item => {
            return fetchBasicJsonPost('/Workflow/AddApprover', {
                data: item
            });
        },
        delete: item => {
            return fetchBasicJsonPost('/Workflow/DeleteApprover', {
                data: item
            });
        }
    },
    Filter: {
        getData: (page, itemsPerPage, filter, signal) => {
            var parameters = {
                page: page,
                pageSize: itemsPerPage
            };
            parameters.name = filter.search || null;
            return fetchBasicJsonPostJson(
                '/Workflow/GetFilterDataTableData',
                {
                    data: parameters,
                    signal: signal
                },
                { useBlock: !signal }
            );
        },
        add: item => {
            return fetchBasicJsonPost('/Workflow/AddFilter', {
                data: item
            });
        },
        edit: item => {
            return fetchBasicJsonPost('/Workflow/EditFilter', {
                data: item
            });
        },
        delete: item => {
            return fetchBasicJsonPost('/Workflow/DeleteFilter', {
                data: item
            });
        }
    },
    FilterField: {
        getData: (page, itemsPerPage, filter) => {
            var parameters = {
                page: page,
                pageSize: itemsPerPage
            };
            parameters.table = filter.table || null;
            parameters.field = filter.field || null;
            parameters.filter_id = filter.filter_id || null;
            return fetchBasicJsonPostJson(
                '/Workflow/GetFilterFieldDataTableData',
                {
                    data: parameters
                }
            );
        },
        add: item => {
            return fetchBasicJsonPost('/Workflow/AddFilterField', {
                data: item
            });
        },
        delete: item => {
            return fetchBasicJsonPost('/Workflow/DeleteFilterField', {
                data: item
            });
        }
    },
    StepFilter: {
        getData: (page, itemsPerPage, filter) => {
            var parameters = {
                page: page,
                pageSize: itemsPerPage
            };
            parameters.generator_id = filter.generator_id;
            parameters.level = filter.level;
            parameters.step = filter.step;
            return fetchBasicJsonPost('/Workflow/GetStepFilterDataTableData', {
                data: parameters
            });
        },
        add: item => {
            return fetchBasicJsonPost('/Workflow/AddStepFilter', {
                data: item
            });
        },
        delete: item => {
            return fetchBasicJsonPost('/Workflow/DeleteStepFilter', {
                data: item
            });
        }
    },
    AdditionalFilter: {
        getData: (page, itemsPerPage, filter) => {
            var parameters = {
                page: page,
                pageSize: itemsPerPage
            };
            parameters.table = filter.table || null;
            parameters.field = filter.field || null;
            parameters.filter_id = filter.filter_id || null;
            return fetchBasicJsonPostJson(
                '/Workflow/GetAdditionalFilterDataTableData',
                {
                    data: parameters
                }
            );
        },
        add: item => {
            return fetchBasicJsonPost('/Workflow/AddAdditionalFilter', {
                data: item
            });
        },
        delete: item => {
            return fetchBasicJsonPost('/Workflow/DeleteAdditionalFilter', {
                data: item
            });
        }
    },
    GeneratorLevel: {
        getData: generator_id =>
            fetchBasicGetJson(
                `/Workflow/GetGeneratorLevels?generatorId=${generator_id}`
            ),
        getTableActionLevels: async (table_id, action_id, settings) =>
            fetchBasicGetJson(
                `/Workflow/GetTableActionLevels?table=${table_id}&workflowAction=${action_id}`,
                settings
            )
    },
    cancelRequest: requestId =>
        fetchBasicUrlPost('/Workflow/CancelRequest', {
            data: {
                id: requestId
            }
        })
};
